// extracted by mini-css-extract-plugin
export var externalLink = "_9j-0";
export var internalLinkLabel = "_9j-1";